import { Component, OnInit, ViewChild, Pipe, PipeTransform } from '@angular/core';
import { DocumentoEntradaService } from '../../services/documento-entrada.service';
import { DocumentoEntrada } from '../../model/documento-entrada';
import { ConsorciosService } from '../../services/consorcios.service';
import { Consorcio } from '../../model/consorcio';
import { SucursalService } from '../../services/sucursal.service';
import { SocioService } from '../../services/socio.service';
import { Socio } from '../../model/socio';
import { Sucursal } from '../../model/sucursal';
import { SubirDocumentosService } from '../../services/subir-documentos.service';
import { DocumentoEntradaMantenimientoComponent } from '../../components/documento-entrada-mantenimiento/documento-entrada-mantenimiento.component';
import { DocumentoArchivoSubirResultadoComponent } from '../../components/documento-archivo-subir-resultado/documento-archivo-subir-resultado.component';


@Component({
  selector: 'app-documento-entrada-list',
  templateUrl: './documento-entrada-list.component.html',
  styleUrls: ['./documento-entrada-list.component.css']
})

export class DocumentoEntradaListComponent implements OnInit {

  @ViewChild(DocumentoEntradaMantenimientoComponent) _mantenimientoComponent: DocumentoEntradaMantenimientoComponent;
  @ViewChild(DocumentoArchivoSubirResultadoComponent) _resultado: DocumentoArchivoSubirResultadoComponent;

  public modoEdicion: boolean = false;

  public consorcio: Consorcio;
  public consorcios: Consorcio[];

  public socios: Socio[];
  public socio: Socio;

  public sucursal: Sucursal;
  public sucursales: Sucursal[];

  public documento: DocumentoEntrada;
  public documentos: DocumentoEntrada[];

  public codigoSucursal: string;
  public buscando: boolean = false;

  public query: any;
  public documentoSeleccionado: DocumentoEntrada;

  public ArchivoCargado: boolean = false;
  public NombreArchivo: string = "";
  public csv: any;

  public _guid: string;
  public _cantidadLineas: number;
  public _cantidadLineasEnviadas: number;

  public char_separador: string = ",";

  public verResultadoCarga: boolean;

  public filtro: string;


  constructor(
    private _documentoEntradaService: DocumentoEntradaService,
    private _consorcioService: ConsorciosService,
    private _sucursalService: SucursalService,
    private _socioService: SocioService,
    private _subirDocumentosService: SubirDocumentosService
  ) { }

  ngOnInit() {

    this.filtro = "";
    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.documentos = [];
    this.codigoSucursal = "";
    this.consorcio = null;
    this.sucursal = null;
    this.documentoSeleccionado = new DocumentoEntrada();
    this.cargarConsorcios();

  }

  descargarFormato() {
    document.getElementById('Link_File').click();
  }

  cargarProveedores() {
    this.query = {
      "codigoConsorcio": this.consorcio.codigoConsorcio,
      "tipo": "PROVEEDOR"
    };

    this._socioService.getSocios(this.query)
      .subscribe(
        data => {
          this.socios = data;
          this.asignarProveedores();
        },
        err => {
          console.clear();
          console.log(err._body);
        });
  }


  refrescar() {

    if (this.consorcio === null || this.codigoSucursal === "") {
      return;
    }
    this.cargarDocumentos();

  }

  cambiarSeparador() {
    if (this.char_separador === ",") {
      this.char_separador = ";";
    } else {
      this.char_separador = ",";
    }
  }

  cargarConsorcios() {
    this.query = { "email": sessionStorage.getItem("login") };

    this._consorcioService.getConsorciosUsuario(this.query)
      .subscribe(
        data => { this.consorcios = data; },
        err => {
          console.log(err);
        });
  }

  cargarSucursales() {

    if (this.consorcio === null) {
      return;
    }
    this.query = { "email": sessionStorage.getItem("login"), "codigoConsorcio": this.consorcio.codigoConsorcio }

    this._sucursalService.getSucursalesUsuario(this.query)
      .subscribe(
        data => this.sucursales = data,
        err => {
          console.clear();
          console.log(err._body);
        });
  }


  agregarRegistro() {
    if (this.consorcio === null || this.sucursal === null) {
      return;
    }

    this.modoEdicion = true;
    this._mantenimientoComponent.agregarDocumento(this.consorcio, this.sucursal);

  }

  regresar() {
    this.modoEdicion = false;
    this.cargarDocumentos();
  }

  asignarProveedores() {
    for (let i = 0; i < this.documentos.length; i++) {
      for (let x = 0; x < this.socios.length; x++) {
        if (this.documentos[i].codigoCliente === this.socios[x].codigoSocio) {
          this.documentos[i].nombreProveedor = this.socios[x].nombre;
        }
      }
    }
  }

  cargarDocumentos() {
    if (this.consorcio === null || this.sucursal === null) {
      return;
    }

    this.query = {
      codigoConsorcio: this.consorcio.codigoConsorcio,
      codigoSucursal: this.sucursal.codigoSucursal
    };

    this._documentoEntradaService.getDocumentos(this.consorcio.codigoConsorcio, this.sucursal.codigoSucursal)
      .subscribe(
        data => {
          this.documentos = data;
          this.cargarProveedores();
        },
        err => {
          console.clear();
          console.log(err._body);
        });
  }

  editarRegistro(documento: DocumentoEntrada) {
    this.modoEdicion = true;
    this._mantenimientoComponent.editarDocumento(this.consorcio, this.sucursal, documento);
  }


  onChangeFile(event) {
    this.ArchivoCargado = true;
    var file = event.target.files[0] || event.srcElement.files[0];
    this.NombreArchivo = file.name;
    this.csv = file;
  }

  guardarArchivo(arr: any, service: SubirDocumentosService) {
    this._subirDocumentosService.insert(arr)
      .subscribe(
        data => {
          alert("El archivo ha sido cargado...");
          this.cargarDocumentos();
        },
        err => {
          console.log(err._body);
        });
  }

  guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }

  prepararEnvio(arrDoc: any, arrSync: any, arrDocID: any) {

    if (arrSync.length > 0) {
      for (var i = 0; i < arrSync.length; i++) {
        delete arrDoc[this.findIndex(arrDoc, arrSync[i], "ID_SYNC")];
        arrDoc.sort();
        arrDoc.length = arrDoc.length - 1;
        this._cantidadLineasEnviadas = this._cantidadLineasEnviadas + 1;
      }
    }

    if (arrDoc.length > 0) {
      var arrToSync = [];
      if (arrDoc.length > 100) {
        for (var x = 0; x < 100; x++) {
          arrToSync.push(arrDoc[x]);
        }
      } else {
        arrToSync = arrDoc;
      }



      this._subirDocumentosService.insert(arrToSync)
        .subscribe(
          data => {
            this.prepararEnvio(arrDoc, data.Resultado, arrDocID);
          },
          err => {
            console.log(err._body);
          });
    } else {
      if (this._cantidadLineas === this._cantidadLineasEnviadas) {
        this._subirDocumentosService.confirmar(this._guid)
          .subscribe(
            data => {
              alert("El archivo ha sido cargado...");
              this.buscando = false;
              this.cargarDocumentos();
              this.obtenerResultadoSubidos();
            },
            err => {
              this.buscando = false;
              console.log(err._body);
            });
      } else {
        alert("Error al subir el archivo:  Diferencia en la cantidad de líneas por subir...");
        this.buscando = false;
        this._subirDocumentosService.RevertirSubida({ "ID_Session": this._guid });
        this.cargarDocumentos();
      }
    }


  }

  obtenerResultadoSubidos() {
    this._resultado.cargarDatos(this._guid);
    this.verResultadoCarga = true;
  }

  volverDocumentos() {
    this.verResultadoCarga = false;
  }

  findIndex(arr, query, property) {
    for (var i = 0, len = arr.length; i < len; i++) {
      if (arr[i][property] === query) return i;
    }
    return -1;
  }

  cargarArchivo() {

    // if(this.socio === null){
    //     return;
    // }
    this.ArchivoCargado = false;
    var guardar = this.guardarArchivo;
    var servicio = this._subirDocumentosService;
    var oFReader = new FileReader();
    var retorno = false;

    oFReader.onloadend = (e) => {

      this._guid = this.guid();

      var Lines = oFReader.result.split("\n");

      var Headers = Lines[0].replace(/"/g, '').split(this.char_separador);
      var arr = [];
      var arr_Articulos = [];
      var arr_Doc = [];
      for (var i = 1; i < ((Lines.length) - 1); i++) {
        var patt = new RegExp(this.char_separador + this.char_separador);
      //  if (!patt.test(Lines[i])) {
          var Current_Line = Lines[i].replace(/"/g, '').split(this.char_separador);
          var Obj = {};
          Obj["ID_SYNC"] = i;
          for (var j = 0; j < Headers.length; j++) {
            if (Headers[j] === "CANTIDAD") {
              Obj[Headers[j].replace(/"/g, '')] = parseInt(Current_Line[j]);
            } else {
              Obj[Headers[j].replace(/"/g, '')] = Current_Line[j];
            }
          }
          if (Obj["TIPODOCUMENTO"] != "REC") {
            alert("El documento no pertenece a una Recepción");
            retorno = true;
            break;
          }
          if (!/this.consorcio.documentoPrefijo/.test(Obj["CODIGODOCUMENTO"])) {
            Obj["CODIGODOCUMENTO"] = this.consorcio.documentoPrefijo + "-" + Obj["CODIGODOCUMENTO"];
          }
          Obj["SESION"] = this._guid;
          Obj["CODIGOBODEGA"] = this.consorcio.codigoBodega;
          //   Obj["CODIGOCLIENTE"] = this.socio.codigoSocio;
          Obj["CODIGOCONSORCIO"] = this.consorcio.codigoConsorcio;
          Obj["CODIGOSUCURSAL"] = this.sucursal.codigoSucursal;
          Obj["TIPO"] = "ENTRADA";
          Obj["FECHA"] = Obj["FECHA"].replace(/\//g, '-');
          arr.push(Obj);
          arr_Articulos.push({ "codigoArticulo": Obj["CODIGOARTICULO"] });
          if (this.findIndex(arr_Doc, Obj["CODIGODOCUMENTO"], "CODIGODOCUMENTO")) {
            arr_Doc.push({ "TIPO": "ENTRADA", "CODIGODOCUMENTO": Obj["CODIGODOCUMENTO"] });
          }
     //   }
      }

      if (retorno) {
        return;
      } else {
        this.buscando = true;
        this._cantidadLineas = arr.length;
        this._cantidadLineasEnviadas = 0;
        this.prepararEnvio(arr, [], arr_Doc);

      }
    }
    oFReader.readAsText(this.csv, 'ISO-8859-1');
  }


  buscarArchivo() {
    if (this.consorcio === null || this.sucursal === null) {
      return;
    }
    document.getElementById("Button_File").click();
  }

}


// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/documento-entrada-list/documento-entrada-list.component.ts